import {SET_IS_DELETED_PROFILE, SET_IS_PASSWORD_RESETED, SET_PROFILE, SET_USER} from "./user-types";


export const setUser = (user) => ({type: SET_USER, user})
export const setProfile = (profile) => ({type: SET_PROFILE, profile})
export const setIsPasswordReseted = (isPasswordReseted) => ({type: SET_IS_PASSWORD_RESETED, isPasswordReseted})
export const setIsDeletedProfile = (isDeletedProfile) => ({type: SET_IS_DELETED_PROFILE, isDeletedProfile})
